<script>
export default {
    data() {
        return {
            firstName: '',
            lastName: '',
            email: ''
        }
    },
    props: [
        'compactLayout',
        'title',
        'showTitle',
        'benefits',
        'subHeading',
        'themeDir'
    ],
    methods: {

    },
}
</script>

<style>

</style>

<template>
    <div v-if="compactLayout === '1'" class="bg-sky-50 rounded-2xl p-8">
        <h1 class='text-center text-3xl' v-if="showTitle">{{ title }}</h1>
        <form action="https://trial.formitize.com" class="grid grid-cols-1 sm:grid-cols-2 lg:flex lg:flex-row gap-4 md:gap-8">
            <div class="lg:grow">
                <label for="FirstName" class='block w-full'>First Name *</label>
                <input type="text" name="firstName" v-model="firstName" id="FirstName" class='bg-white border shadow-lg w-full py-3 px-4' placeholder="Jane">
            </div>
            <div class="lg:grow">
                <label for="LastName" class='block w-full'>Last Name *</label>
                <input type="text" name="lastName" v-model="lastName" id="LastName" class='bg-white border shadow-lg w-full py-3 px-4' placeholder="Smith">
            </div>
            <div class="lg:grow">
                <label for="Email" class='block w-full'>Email *</label>
                <input type="email" name="email" v-model="email" id="Email" class='bg-white border shadow-lg w-full py-3 px-4' placeholder="janesmith@example.com">
            </div>
            <div class='sm:mt-1.5 lg:shrink-0 lg:grow-0'>
                <button type='submit' class='btn btn-primary'>Try for free</button>
            </div>
        </form>
    </div>
    <form action="https://trial.formitize.com" v-else class="bg-sky-50 rounded-2xl p-12 xl:p-16">
        <h1 class='lg:w-1/2' v-if="showTitle">{{ title }}</h1>

        <div class='md:flex md:gap-12'>
            <div class='md:w-3/5'>
                <p v-if="subHeading" class='text-xl'>{{subHeading}}</p>
                <div class="grid grid-cols-1 gap-8 mt-8">
                    <div>
                        <label for="FirstName" class='block w-full'>First Name *</label>
                        <input type="text" name="firstName" v-model="firstName" id="FirstName" class='bg-white border shadow-lg w-full py-3 px-4' placeholder="Jane">
                    </div>
                    <div>
                        <label for="LastName" class='block w-full'>Last Name *</label>
                        <input type="text" name="lastName" v-model="lastName" id="LastName" class='bg-white border shadow-lg w-full py-3 px-4' placeholder="Smith">
                    </div>
                    <div>
                        <label for="Email" class='block w-full'>Email *</label>
                        <input type="email" name="email" v-model="email" id="Email" class='bg-white border shadow-lg w-full py-3 px-4' placeholder="janesmith@example.com">
                    </div>
                    <div>
                        <button type='submit' class='btn btn-primary'>Try for free</button>
                    </div>
                </div>
            </div>
            <div class='hidden md:block md:w-2/5'>
                <ul>
                    <li v-for="benefit in benefits" class='benefit pl-12 mb-6 xl:mb-12 bg-left-top bg-no-repeat' :style="{'background-image': `url(${themeDir}/images/tick.svg)`}">{{ benefit }}</li>
                </ul>
            </div>
        </div>
    </form>
</template>
